<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb
      :items="items"
      :canAddNew="!canAdd"
      search_route="/certificates/add"
      search_title="اضافه شهادة جديدة"
      icon="fa-plus"
    />
    <!-- End Breadcrumb -->
    <!-- <main-filter @getResult="setRows" /> -->
    <!-- Start Main Loader -->
    <!-- End Breadcrumb -->
    <MainLoader v-if="loading"></MainLoader>

    <div class="fadeIn" v-else>
      <!-- Start Main Section -->

      <main>
        <div class="d-flex flex-wrap justify-content-center">
          <div
            class="col-3 py-0"
            v-for="certificate in Certificates"
            :key="certificate.id"
          >
            <CertificateCard
              :canEdited="!canEdit"
              :canDeleted="!canDelete"
              :cardData="certificate"
              @deleteThis="deleteItem"
            />
          </div>
        </div>
      </main>
      <!-- ======================== Start Top Section ======================== -->
      <!-- Delete dialog -->
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5 justify-center">
            {{ $t("table.deletedialog.areYouSure") }}
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#1B5E20" @click="deleteItemConfirm">
              {{ $t("table.deletedialog.ok") }}
            </v-btn>
            <v-btn color="#F44336" @click="dialogDelete = false">
              {{ $t("table.deletedialog.cancel") }}
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ======================== End Top Section ======================== -->
      <!-- End Main Section -->

      <!-- Start Pagination -->
      <template>
        <div
          class="pagination_container tw-text-center mb-5 d-flex justify-content-end"
        >
          <v-pagination
            color="primary"
            v-model="paginations.current_page"
            :length="paginations.last_page"
            :total-visible="5"
            @input="fetchData($event)"
          ></v-pagination>
        </div>
      </template>
      <!-- End Pagination -->
    </div>

    <!-- Start Image_Model -->
    <base-model
      @closeModel="model_1.show_model = false"
      :show="model_1.show_model"
    >
      <div class="image">
        <img
          v-if="model_1.model_img_src"
          :src="model_1.model_img_src"
          alt="..."
        />
      </div>
    </base-model>
    <!-- End Image_Model -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    CertificateCard: () =>
      import("../../../components/UI/cards/Certificate.vue"),
  },
  data() {
    return {
      Certificates: [],
      // ========== Main Loader
      loaderPage: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.certificates.title"),
          disabled: false,
          href: "/certificates/show-all",
        },
        {
          text: this.$t("breadcrumb.certificates.all"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },

      // ========== Body Section
      calories: "",

      // ========== Your Data
      rows: [], // injected in created

      // ========== elected Data
      selected: [],
      singleSelect: false,

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 20,
      },

      // ========== Loding
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
          },
          {
            text: "الشهادة",
            align: "center",
            value: "color",
            sortable: true,
          },
          {
            text: "الرابط",
            align: "center",
            value: "ar.name",
            sortable: true,
          },
          {
            text: "الاجراءات",
            align: "center",
            value: "actions",
            sortable: true,
          },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "Certification",
            align: "center",
            value: "color",
            sortable: true,
          },
          {
            text: "Link",
            align: "center",
            value: "ar.name",
            sortable: true,
          },
          {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      }
    },
  },

  methods: {
    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },

    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/colors/add" });
    },
    showItem(item) {
      this.$router.push({ path: "/colors/show/" + item.id });
    },
    editItem(item) {
      this.$router.push({ path: "/colors/edit/" + item.id });
    },

    // ===== Delete
    deleteItem(item) {
      console.log(item);
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.axios({
        method: "DELETE",
        url: `certification/${this.itemtoDelete}`,
      })
        .then(() => {
          this.Certificates = this.Certificates.filter((item) => {
            return item.id != this.itemtoDelete;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows(e) {
      this.loaderPage = true;
      this.loading = true;

      this.axios({
        method: "GET",
        url: "certification",
        params: {
          page: this.paginations.current_page,
          keyword: e?.searchInput ? e.searchInput : "",
        },
      })
        .then((res) => {
          // this.rows = res.data.data
          this.Certificates = res.data.data;
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;

          // this.statisticsItem.number = res.data.meta.total

          this.loading = false;
          this.loaderPage = false;
        })
        .catch(() => {
          this.loading = false;
          this.loaderPage = false;
        });
    },
    fetchData(e) {
      this.$router.replace({ query: { page: e } });
      this.setRows();
    },
  },
  created() {
    this.canEdit = this.$permission.allowed("certificates/edit/");
    this.canDelete = this.$permission.allowed("certificates/delete");
    this.canAdd = this.$permission.allowed("certificates/add");
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setRows();
  },
};
</script>

<style lang="scss" scoped>
.image {
  width: 80px;
  img {
    width: 100%;
  }
}
.certificate {
  border: 1px solid #8f98c54d;
  border-radius: 5px;
  width: 90%;
  margin: auto;
  // display: flex;
  // justify-content: center;
  img {
    display: block;
    width: 170px;
    // min-height: 200px;
    margin: auto;
  }
  .delete_button {
    background: red !important;
    font-size: 18px;
    color: #fff;
    width: 50%;
    * {
      font-size: 18px;
      color: #fff;
      background: none;
    }
  }
  .edit_link {
    width: 50%;
    text-align: center;
    background: #29398c !important;
    margin: 0;
    * {
      font-size: 18px;
      color: #fff;
      background: none;
    }
  }
  a {
    display: block;
    // padding-inline: 15px;
    color: #29398c;
    text-align: center;
    margin-block-end: 20px;
  }
}
</style>
